import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";
import { getAccessToken } from "./authToken";

function connectToSocket() {
  const token = getAccessToken();

  return openSocket(getBackendUrl(), {
    transports: ["websocket", "polling"],
    auth: token ? { token } : {},
  });
}

export default connectToSocket;
